import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addconstactlist, getconstactlist, updateconstactlist } from "../redux-toolkit/Slice/contactlistSlice";
import { GET_contactlist, POST_contactlist, PUT_contactlist } from "../redux-toolkit/ApiEndpoint";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
    const dispatch = useDispatch();

    const [formValues, setFormValues] = useState({
        email: "",
        phone: "",
        locations: "",
    });

    const [uuid, setUuid] = useState(null); // Store the UUID for updates
    const { constactlistdata } = useSelector((state) => state.contactlist);

    useEffect(() => {
        dispatch(getconstactlist({
            endpoint: GET_contactlist,
        }));
    }, [dispatch]);

    useEffect(() => {
        if (constactlistdata?.length > 0) {
            const data = constactlistdata[0]; // Assuming you want the first item's data
            setFormValues({
                email: data.email || "",
                phone: data.phone || "",
                locations: data.locations || "",
            });
            setUuid(data.uuid); // Set the UUID for updates
        }
    }, [constactlistdata]);

    const handlesubmit = (e) => {
        e.preventDefault();

        if (uuid) {
            // Update existing contact
            dispatch(updateconstactlist({
                endpoint: PUT_contactlist,
                uuid: uuid,
                payload: formValues,
            }))
                .unwrap()
                .then(() => {
                    toast.success("Contact List updated successfully!");
                })
                .catch((error) => {
                    toast.error(error || "Failed to update the Contact List.");
                });
        } else {
            // Create a new contact
            dispatch(
                addconstactlist({
                    endpoint: POST_contactlist,
                    payload: formValues,
                })
            )
                .unwrap()
                .then(() => {
                    toast.success("Contact List created successfully!");
                })
                .catch((error) => {
                    toast.error(error || "Failed to create the Contact List.");
                });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    return (
        <main className="page-padding">
            <ToastContainer />
            <section className="contact-wrapper p-0">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-10">
                            <div
                                className="form-wrapper"
                                data-aos="fade-right"
                                data-aos-duration="3000"
                            >
                                <h2 className="title">Update User Contact Info</h2>
                                <div className="col-12">
                                    <hr />
                                </div>
                                <form onSubmit={handlesubmit}>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-12 mb-4">
                                            <label htmlFor="email" className="mb-2">
                                                Change Your Email
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                name="email"
                                                placeholder="Your Email"
                                                value={formValues.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12 mb-4">
                                            <label htmlFor="phone" className="mb-2">
                                                Change Your Number
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="phone"
                                                name="phone"
                                                placeholder="Your Number"
                                                value={formValues.phone}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-lg-12 mb-4">
                                            <label htmlFor="locations" className="mb-2">
                                                Change Your Address
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="locations"
                                                name="locations"
                                                placeholder="Your Address"
                                                value={formValues.locations}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase mt-3 border border-0"
                                    >
                                        Save
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Contact;
